import(/* webpackMode: "eager" */ "/opt/buildhome/repo/marketing/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/marketing/src/styles/tailwind.css");
